import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions, fetchUserStatus, loadSettings, setSetting } from "../actions";
import { AppSettings, Character, State } from "../types";

import { getAppInstallationId, setSocketId } from "../helpers/authorizationHelpers";
import { socket } from "../api";

interface Props {
}
const DataLoader: React.FC<Props> = () => {

    const settings: AppSettings = useSelector((store: State) => store.settings)
    const dispatch: any = useDispatch();

    useEffect(() => {
        if (!settings.dataLoaderHasRun) {
            console.log("DataLoader: Load Settings")
            dispatch(loadSettings());
            dispatch(fetchUserStatus());
            return;
        }
    });

    useEffect(() => {

        function onConnect() {
            dispatch(setSetting({ socketStatus: "connected", socket: socket }));
            socket.emit("authenticate", getAppInstallationId())
        }
        function onDisconnect() {
            console.log("Websocket disconnected")
            dispatch(setSetting({ socketStatus: "disconnected", socket: undefined }));
        }
        function onWhoAreYouEvent(id: string) {
            setSocketId(id)
            socket.emit("authenticate", getAppInstallationId())
        }
        function onAuthenticatedEvent() {
            dispatch(setSetting({ socketStatus: "authenticated" }));
            // socket.emit("getCharacters")
        }
        function onAuthErrorEvent() {
            console.log("Websocket did not authenticate")
            dispatch(setSetting({ socketStatus: "connected" }));
        }
        function onCharacters(c: Character[]) {
            dispatch(actions.setCharactersAction(c));
        }
        function onAlert(message: string) {
            console.log("ALERT:", message)
            alert(message)
        }

        socket.on("connect", onConnect);
        socket.on("disconnect", onDisconnect);
        socket.on("whoareyou", onWhoAreYouEvent);
        socket.on("authenticated", onAuthenticatedEvent);
        socket.on("authError", onAuthErrorEvent);
        socket.on("characters", onCharacters);
        socket.on("alert", onAlert);

        return () => {
            socket.off("connect", onConnect);
            socket.off("disconnect", onDisconnect);
            socket.off("whoareyou", onWhoAreYouEvent);
            socket.off("authenticated", onAuthenticatedEvent);
            socket.off("authError", onAuthErrorEvent);
            socket.off("characters", onCharacters);
            socket.off("alert", onAlert);
        };
    }, [dispatch]);

    return <></>
}

export default DataLoader
